<script>
import SidebarMenuItem from "@/components/GlobalSidebarMenuItem"

import { match } from "path-to-regexp"

export default {
    name: "SidebarMenu",
    components: {
        SidebarMenuItem,
    },
    props: {
        menu: {
            type: Array,
            required: true,
        },
    },
    methods: {
        isRouteCollapsed(item) {
            if (item.filtered) {
                return false
            }

            const aliases = item.aliases
            const childrenOpen = aliases?.some((alias) => {
                // Convert the alias to a RegExp pattern using `match`
                const matchFn = match(alias, { decode: decodeURIComponent })
                const result = matchFn(this.$route.path)

                // The route is active if the result is not false
                return result !== false
            })

            return !childrenOpen
        },
    },
}
</script>

<template>
    <div id="sidebar-content-wrapper">
        <SidebarMenuItem
            :item="item"
            :key="`${item.id}-${item.title}`"
            v-for="item in menu"
            :collapse="isRouteCollapsed(item)"
        />
    </div>
</template>

<style scoped></style>
